import { ToasterService } from '../services/toaster.service';
import useService from '../../injector/hooks/useService';

const useToaster = () => useService(ToasterService);

export default useToaster;
